import { useTranslation } from '@/contexts/i18n-context';
import { useMediaQuery } from '@/hooks/use-media-query';
import clsx from 'clsx';
import { FooterLinks } from './footer-links';
import styles from './footer.module.css';
import { useFooterConfig } from './use-footer-config';
import { AppLogo } from '../app-logo';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const isMobile = useMediaQuery('--screen-md');
  const { t } = useTranslation();
  const footerConfig = useFooterConfig();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.paymentOptions}>
            <AppLogo className={styles.logo} />
            <p className={clsx('body-3', styles.paymentOptionsText)}>
              {t('footer.paymentOptions')}
            </p>
          </div>
          <div className={styles.linksContainer}>
            {isMobile && <AppLogo className={styles.logo} />}
            <div className={styles.links}>
              {footerConfig.linksGroupOrder.map((linkGroupKey) => (
                <FooterLinks
                  key={linkGroupKey}
                  title={footerConfig.linksGroups[linkGroupKey].label}
                  links={footerConfig.linksGroups[linkGroupKey].links}
                />
              ))}
            </div>
          </div>
        </div>
        <p className={clsx('body-3', styles.copyright)}>
          {t('footer.copyright', { year: currentYear })}
        </p>
      </div>
    </footer>
  );
}
